module.exports = __webpack_public_path__ + "png/quick-registration-photo-3.png?f56b76947ab7b86b37bc07cc5e6a067d";